import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const QualityDeltaTabs = () => {
  const { smellType } = useParams();
  const navigate = useNavigate();
  const selected = smellType || "all";

  return (
    <div className="d-flex flex-wrap gap-2">
      {["All", "Architecture", "Implementation", "Design"].map((type) => {
        const route = type.toLowerCase();
        return (
          <button
            key={type}
            className={`btn btn-lg smell-type ${selected === route ? "active" : ""}`}
            onClick={() => navigate(`/quality-delta-explorer/${route}`)}
          >
            {type === "All" ? "Summary" : `${type} smells`}
          </button>
        );
      })}
    </div>
  );
};

export default QualityDeltaTabs;
